import { Component } from '@angular/core';
import { GiftCardPurchaseComponent } from '../gift-card-purchase/gift-card-purchase.component';

@Component({
  selector: 'app-gift-card-online',
  templateUrl: './gift-card-online.component.html',
  standalone: false,
})
export class GiftCardOnlineComponent extends GiftCardPurchaseComponent {}
